export const validateOnlyAlphanumeric = (value) => {
    return /^[a-zA-Z0-9]+$/.test(value);
};
export const isNormalInteger = (str) => {
    if (typeof str !== 'string') {
        return false;
    }
    const n = Number(str);
    return n !== Infinity && String(n) === str && n >= 0;
};
